// Components
import Card from "nhsuk-frontend/packages/components/card/card";
import Checkboxes from "nhsuk-frontend/packages/components/checkboxes/checkboxes";
import Details from "nhsuk-frontend/packages/components/details/details";
import ErrorSummary from "nhsuk-frontend/packages/components/error-summary/error-summary";
// import Header from "nhsuk-frontend/packages/components/header/header";
import Header from "./nhsuk-frontend/header/header.js";
import Radios from "nhsuk-frontend/packages/components/radios/radios";
import SkipLink from "nhsuk-frontend/packages/components/skip-link/skip-link";

import "nhsuk-frontend/packages/polyfills";

function resetTable() {
  const tables = document.querySelectorAll(".wp-block-table");
  const captions = document.querySelectorAll(
    ".wp-block-table .wp-element-caption"
  );
  if (tables) {
    tables.forEach((table) => {
      table.classList.remove("wp-block-table");
      table.classList.add("wp-block-nhsuk-table");
    });
  }
  if (captions) {
    captions.forEach((caption) => {
      caption.classList.add("nhsuk-u-visually-hidden");
    });
  }
}

// Initialize components
document.addEventListener("DOMContentLoaded", () => {
  Card();
  Checkboxes();
  Details();
  ErrorSummary();
  Header();
  Radios();
  SkipLink();
  resetTable();
});
